import React from "react"
import Modal from "components/Modal/Modal"
import { PrimeButton } from "components-design-system"
import "./ForkDeleteModal.scss"
const ForkDeleteModal = ({ onHide, showModal, onSubmit }) => {
  return (
    <Modal
      open={showModal}
      type="delete-alt"
      footer={[]}
      onCancel={onHide}
      className="fork-delete-modal"
    >
      <div className="review-modal-content">
        <div className="review-modal-header">Delete fork?</div>
        <div className="review-modal-text">
          <div>Are you sure you want to delete it?</div>
          <div>You can't undo this action.</div>
        </div>
        <div className="review-modal-actions">
          <PrimeButton onClick={onHide}>Cancel</PrimeButton>
          <PrimeButton
            danger
            onClick={onSubmit}
          >
            Delete
          </PrimeButton>
        </div>
      </div>
    </Modal>
  )
}

export default ForkDeleteModal
